import {
  MeterProvider,
  PeriodicExportingMetricReader,
} from '@opentelemetry/sdk-metrics';
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { metrics } from '@opentelemetry/api';
import { runInProduction } from '@/utils/runtime';

runInProduction(() => {
  // Define your resource, e.g., service name, environment.
  const resource = resourceFromAttributes({
    'service.name': import.meta.env.VITE_OTEL_SERVICE_NAME,
    'deployment.environment': import.meta.env.VITE_OTEL_DEPLOYMENT_ENV,
  });

  // Create a metric reader with OTLP exporter configured to send metrics to a local collector.
  const metricReader = new PeriodicExportingMetricReader({
    exporter: new OTLPMetricExporter({
      url: import.meta.env.VITE_OTEL_METRICS_ENDPOINT,
    }),
    exportIntervalMillis: 30000, // Export metrics every 30 seconds.
  });

  // Initialize a MeterProvider with the above configurations.
  const myServiceMeterProvider = new MeterProvider({
    resource,
    readers: [metricReader],
  });

  // Set the initialized MeterProvider as global to enable metric collection across the app.
  metrics.setGlobalMeterProvider(myServiceMeterProvider);
});
